// extracted by mini-css-extract-plugin
export default {"tag__date":"Tag_tag__date__2Ftbo","tag__format":"Tag_tag__format__C7-Zi","tag__rubric":"Tag_tag__rubric__89G7d","tag__blue":"Tag_tag__blue__d4L1X","tag__red":"Tag_tag__red__gsAU1"};